import { render, staticRenderFns } from "./ReferralIndex.vue?vue&type=template&id=8a1d14e2"
import script from "./ReferralIndex.vue?vue&type=script&lang=js"
export * from "./ReferralIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports